import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

// TODO: Move to another file once new file structure is established
const formatTimeRange = (timeStart: string | number | Date, timeEnd: string | number | Date) => {
  const startDate = new Date(timeStart)
  const endDate = new Date(timeEnd)

  const startTime = format(startDate, 'h:mm')
  const endTime = format(endDate, 'h:mm a')
  const date = format(startDate, 'EEEE, MMMM d')

  return `${startTime}–${endTime} | ${date}`
}

interface HeaderInfoProps {
  name?: string
  timeStart?: string
  timeEnd?: string
}

export const HeaderInfoSection = ({ name, timeStart, timeEnd }: HeaderInfoProps) => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <div className="header-info-section">
      <div className="event-name">{name || t('eventManagement:common.eventName')}</div>
      <div className="event-date">
        {timeStart && timeEnd ? formatTimeRange(timeStart, timeEnd) : ''}
      </div>
    </div>
  )
}
